import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

import { integrationMaxWidth } from "../../style";

export const StyledTableFooter = styled.div`
    width: 100%;
    background-color: ${colorsPalettes.carbon[0]};
    border-top: 1px solid ${colorsPalettes.carbon[100]};
`;

export const StyledTableFooterWrapper = styled.div`
    width: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    padding: 16px 0;

    ${integrationMaxWidth}
`;
